export { default as ROASlider } from './slider'



// WEBPACK FOOTER //
// ./src/components/slider/index.js